import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 引入全局css
import '@/assets/css/global.scss'
// 引入markdown样式
import '@/assets/css/markdown/github-markdown.min.css'
import '@/assets/css/katex/package/dist/katex.min.css'
// 引入mermaid 
import '@/assets/css/mermaid/mermaid.min.css'

// 引入Element
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
// 引入echarts
// import echarts from 'echarts'
import * as echarts from 'echarts' // v5版本
Vue.prototype.$echarts = echarts
import '@/assets/js/echarts/shine.js'
// import 'default-passive-events'

// 引入axios
import axios from 'axios'
Vue.prototype.$axios = axios



import hljs from 'highlight.js'

import './utils/drag'
import './registerServiceWorker'


// 通过 import * as hljs from 'highlight.js' 引入
Vue.directive('highlight', function (el) {
    const blocks = el.querySelectorAll('pre code')
    blocks.forEach(block => {
        hljs.highlightBlock(block)
    })
})




// 创建一个空的Vue实例作为中央事件总线（用它来触发和监听事件,实现组件间的通信）
Vue.prototype.bus = new Vue()

Vue.config.productionTip = false

new Vue({
    router,
    store,
    beforeCreate() {
        // 初始化数据库
        this.$store.dispatch('initDB');
    },
    render: h => h(App),

}).$mount('#app')
